const messages = {
  en: {
    oferta: {
      title: 'Offer management',
      menuTitle: 'Offers',
      subtitle: 'View, search, create, edit and delete Offers',
      creating: 'Creating Offer',
      editing: 'Editing Offer',
      deleting: 'Deleting Offer',
      showing: 'Showing Offer',
      labels: {
        nombre: 'name',
        descripcion: 'description',
        tipo: 'type',
        valor: 'value',
        productos: 'products',
        deposito: 'warehouse',
        diasSemana: 'weekdays',
        fechaInicio: 'start date',
        fechaFin: 'end date',
        mediosPago: 'payment methods',
        activa: 'active',
        inactiva: 'inactive',
        porcentaje: 'percentage discount',
        por_cantidad: 'volume discount',
        cantidadMinima: 'minimum quantity',
        '2x1': '2x1 (Buy 2, get 1 free)',
        '3x2': '3x2 (Buy 3, get 2 free)',
        '4x3': '4x3 (Buy 4, get 3 free)',
      },
    },
  },
  es: {
    oferta: {
      title: 'Administración de Ofertas',
      menuTitle: 'Ofertas',
      subtitle: 'Ver, buscar, crear, editar y borrar Ofertas',
      creating: 'Creando Oferta',
      editing: 'Modificando Oferta',
      deleting: 'Eliminando Oferta',
      showing: 'Detalles de Oferta',
      labels: {
        nombre: 'nombre',
        descripcion: 'descripción',
        tipo: 'tipo',
        valor: 'valor',
        productos: 'productos',
        deposito: 'depósito',
        diasSemana: 'días de la semana',
        fechaInicio: 'fecha de inicio',
        fechaFin: 'fecha de fin',
        mediosPago: 'medios de pago',
        activa: 'activa',
        inactiva: 'inactiva',
        porcentaje: 'porcentaje de descuento',
        por_cantidad: 'por cantidad',
        cantidadMinima: 'cantidad mínima',
        '2x1': '2x1 (Comprar 2, llevar 1 gratis)',
        '3x2': '3x2 (Comprar 3, llevar 2 gratis)',
        '4x3': '4x3 (Comprar 4, llevar 3 gratis)',
        todosLosDias: 'Todos los días',
        sinFechaLimite: 'Sin fecha de fin',
        lunes: 'Lunes',
        martes: 'Martes',
        miercoles: 'Miércoles',
        jueves: 'Jueves',
        viernes: 'Viernes',
        sabado: 'Sábado',
        domingo: 'Domingo',
      },
    },
  },
  pt: {
    oferta: {
      title: 'Administração de Ofertas',
      menuTitle: 'Ofertas',
      subtitle: 'Ver, buscar, criar, editar e usar Ofertas',
      creating: 'Criando Oferta',
      editing: 'Edição Oferta',
      deleting: 'Apagando Oferta',
      showing: 'Detalhes do Oferta',
      labels: {
        nombre: 'nome',
        descripcion: 'descrição',
        tipo: 'tipo',
        valor: 'valor',
        productos: 'produtos',
        deposito: 'depósito',
        diasSemana: 'dias da semana',
        fechaInicio: 'data de início',
        fechaFin: 'data de fim',
        mediosPago: 'métodos de pagamento',
        activa: 'ativa',
        inactiva: 'inaciva',
        porcentaje: 'desconto percentual',
        por_cantidad: 'por quantidade',
        cantidadMinima: 'quantidade mínima',
        '2x1': '2x1 (Comprar 2, levar 1 grátis)',
        '3x2': '3x2 (Comprar 3, levar 2 grátis)',
        '4x3': '4x3 (Comprar 4, levar 3 grátis)',
      },
    },
  }
}

export default messages

